import { render, staticRenderFns } from "./tcxfPackage.vue?vue&type=template&id=6d8eba9e&scoped=true&"
import script from "./tcxfPackage.vue?vue&type=script&lang=js&"
export * from "./tcxfPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8eba9e",
  null
  
)

export default component.exports